import * as z from "zod";

import { issueSchema } from "./issue";

export enum IssueLinkType {
  RELATE = "relate",
  BLOCK = "block",
}

const issueLinkCreateInSchema = z.object({
  inIdentifier: issueSchema.shape.identifier,
  type: z.nativeEnum(IssueLinkType),
});
const issueLinkCreateOutSchema = z.object({
  outIdentifier: issueSchema.shape.identifier,
  type: z.nativeEnum(IssueLinkType),
});

export const issueLinkCreateSchema = z.union([
  issueLinkCreateInSchema,
  issueLinkCreateOutSchema,
]);

export type IssueLinkCreate = z.infer<typeof issueLinkCreateSchema>;
